export default __webpack_public_path__ + "static/twitter-bec7e16445f382d29668a339ca9f0412.svg";